/**
 * custom.js — Source-agnostic zip code handler
 *
 * Works identically with both ASL and ipapi.co zip detection.
 * asl_snippet.liquid detects the zip (the "how"), then calls
 * window.asl_loaded() which is defined here and owns all
 * post-detection behavior (the "what happens after").
 *
 * Responsibilities:
 *   - Initialize zip state + analytics values
 *   - Wire all modal event handlers (Apply, Change, Done, zone-select)
 *   - Clear cart silently on zip change
 *   - Redirect to /collections/all when zip changes on a PDP
 *   - Intercept add-to-cart to stamp cartZipValue for analytics
 *   - Expose checkZipSupplier() for supplier matching
 */

window.close_modal = function () {
  $("#asl_popup_wrapper").hide();
};

window.show_modal = function () {
  $("#asl_popup_wrapper").show();
};

function buildOverrideUrl(paramName, paramValue) {
  const href = window.location.href;
  const joinChar = href.indexOf("?") === -1 ? "?" : "&";
  return href + joinChar + paramName + "=" + paramValue;
}

function checkZipSupplier(zip) {
  let matchedSupplier = null;
  try {
    if (window.zipSupplierMap && typeof window.zipSupplierMap === "object") {
      for (const supplier in window.zipSupplierMap) {
        const zipsArray = window.zipSupplierMap[supplier];
        if (zipsArray && zipsArray.includes(zip.trim())) {
          matchedSupplier = supplier;
          break;
        }
      }
    } else {
      console.warn("window.zipSupplierMap is not defined or not an object.");
    }
  } catch (err) {
    console.warn("Error checking zipSupplierMap:", err);
  }
  console.log("checkZipSupplier() => Matched supplier:", matchedSupplier);
}

// Helper to retrieve the current zip from localStorage.
function getCurrentZip() {
  const storedOverride = localStorage.getItem("zip_override");
  if (storedOverride && storedOverride.length >= 5 && storedOverride !== "null") {
    return storedOverride;
  }
  const detected = localStorage.getItem("detectedZip");
  if (detected && detected !== "null") {
    return detected;
  }
  return null;
}

// Helper to update the zip in localStorage.
function setCurrentZip(zip) {
  if (zip && zip.length >= 5) {
    localStorage.setItem("zip_override", zip);
  }
}

/* ================================================================
   Shared zip change handler — called by ALL zip change entry points
   Clears cart, updates all localStorage keys, navigates.
   ================================================================ */
let zipChangeInProgress = false;

function applyZipChange(newZip) {
  if (zipChangeInProgress) return;
  zipChangeInProgress = true;

  // Update all localStorage keys
  localStorage.setItem("zip_override", newZip);
  localStorage.setItem("currentZipValue", newZip);
  localStorage.setItem("cartZipValue", newZip);
  localStorage.removeItem("zipVariantDataCache");

  // Update global
  window.currentZip = newZip;

  // Analytics
  checkZipSupplier(newZip);

  console.log("applyZipChange() => clearing cart, navigating for zip:", newZip);

  // Clear cart then navigate
  fetch("/cart/clear.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  }).finally(function () {
    if (window.location.pathname.startsWith("/products")) {
      window.location.href = "/collections/all";
    } else {
      window.location.reload();
    }
  });
}

/* ================================================================
   Intercept add-to-cart to stamp cartZipValue (from zip-cart-guard)
   ================================================================ */
function interceptAddToCart() {
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const [url] = args;
    if (url && (url.includes("/cart/add") || url === "/cart/add.js")) {
      const zip = getCurrentZip();
      if (zip && !localStorage.getItem("cartZipValue")) {
        localStorage.setItem("cartZipValue", zip);
        console.log("interceptAddToCart() => stamped cartZipValue:", zip);
      }
    }
    return originalFetch.apply(this, args);
  };
}

/* ================================================================
   asl_loaded() — Called by BOTH ASL remote script and ipapi.co
   block after zip detection is complete. Owns all post-detection
   behavior: state init, analytics, event handlers.
   ================================================================ */
window.asl_loaded = function () {
  let aslInputZip = false;
  const $zipInput = $("#enter_zip_code");
  const $popupWrapper = $("#asl_popup_wrapper");
  const $doneBtn = $(".done_btn");
  $popupWrapper.hide();

  // --- Initialization: Persist initial detected zip once ---
  let storedDetectedZip = localStorage.getItem("detectedZip");
  if (!storedDetectedZip || storedDetectedZip === "null") {
    try {
      const zipFromFunction = asl_zip(); // Only exists in ASL mode
      storedDetectedZip = zipFromFunction;
      localStorage.setItem("detectedZip", zipFromFunction);
    } catch (err) {
      // Expected in ipapi mode — asl_zip() doesn't exist
      console.log("asl_loaded() => asl_zip() not available (ipapi mode)");
    }
  }

  // --- Set the current zip from localStorage ---
  var currentZip = getCurrentZip();
  // Fallback to the detected zip if needed.
  if (!currentZip || currentZip.length < 5) {
    currentZip = storedDetectedZip;
  }
  // Also assign it to the global variable.
  window.currentZip = currentZip;
  // Store in localStorage for analytics or other usage.
  if (currentZip) {
    localStorage.setItem("currentZipValue", currentZip);
  }

  // Populate the input with the current zip.
  $zipInput.val(currentZip);
  console.log("asl_loaded() => detectedZip:", storedDetectedZip);
  console.log("asl_loaded() => currentZip:", currentZip);

  // Mark the default address based on currentZip.
  $('[data-zip="' + currentZip + '"]')
    .addClass("asl-default-address")
    .append("<span>Default address</span>");

  if (currentZip && currentZip.length >= 5) {
    checkZipSupplier(currentZip);
  }

  // Only show the modal if there's no valid zip_override and the popup wasn't previously rejected.
  const storedZip = localStorage.getItem("zip_override");
  const rejectPopup = localStorage.getItem("reject_asl_popup");
  if ((!storedZip || storedZip.length < 5 || storedZip === "null") && !rejectPopup) {
    window.show_modal();
  }

  // --- Intercept add-to-cart for cartZipValue stamping ---
  interceptAddToCart();

  // --- Event Handlers ---

  function handleDoneButton() {
    const zipcode = $zipInput.val();
    if (aslInputZip && zipcode.length > 4) {
      if (zipcode !== currentZip) {
        currentZip = zipcode;
        applyZipChange(zipcode);
      } else {
        // Same zip, just close
        window.close_modal();
      }
    } else {
      localStorage.setItem("reject_asl_popup", 1);
      window.close_modal();
    }
  }

  $doneBtn.on("click", function (e) {
    e.preventDefault();
    handleDoneButton();
  });

  $zipInput.on("keydown", function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      handleDoneButton();
    }
  });

  $(".change-zip-code").on("click", function (e) {
    e.preventDefault();
    aslInputZip = true;
    $(".asl-zip-code-input").show();
    $(".asl-zip-code").hide();
  });

  $(".asl-popup #country").on("change", function () {
    const val = $(this).val();
    if (val.length > 1) {
      window.location.replace(buildOverrideUrl("country_override", val));
    }
  });

  $("body").on("click", ".asl-zip-code-input-apply", function (e) {
    e.preventDefault();
    const zipcode = $zipInput.val();
    try {
      if (zipcode === currentZip) {
        window.close_modal();
      } else if (zipcode.length >= 5) {
        currentZip = zipcode;
        applyZipChange(zipcode);
      }
    } catch (err) {
      console.error("Error in .asl-zip-code-input-apply:", err);
    }
  });

  // Wire the #close_popup (Apply/Done) button with capture phase
  // so it runs before theme.liquid's bubble-phase handler.
  // Note: #close_popup is the same element as .done_btn
  // (a#close_popup.asl-btn.done_btn). The capture handler
  // intercepts zip changes; the jQuery .done_btn handler above
  // handles the non-edit-mode "reject popup" case.
  var applyEl = document.getElementById("close_popup");
  if (applyEl && !applyEl.dataset.zipWired) {
    applyEl.dataset.zipWired = "true";
    applyEl.addEventListener(
      "click",
      function (e) {
        var input = document.querySelector(".asl-zip-code-input input");
        var newZip = input && input.value ? input.value.trim() : "";
        if (newZip && /^\d{5}$/.test(newZip) && newZip !== currentZip) {
          e.preventDefault();
          e.stopImmediatePropagation();
          currentZip = newZip;
          applyZipChange(newZip);
        }
        // If same zip or no valid input, fall through to
        // theme.liquid's handler which closes the modal
      },
      true
    ); // capture phase
  }

  $("body").on("click", ".header-delivery", function () {
    window.show_modal();
  });

  $("body").on("click", ".zone-select", function () {
    const zipcode = $(this).attr("data-zip");
    try {
      if (zipcode === currentZip) {
        window.close_modal();
      } else if (zipcode.length >= 5) {
        currentZip = zipcode;
        applyZipChange(zipcode);
      }
    } catch (err) {
      console.error("Error in .zone-select:", err);
    }
  });

  console.log("asl_loaded() => all handlers wired");
};